import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const COLORS = [
  "#3b82f6", "#8b5cf6", "#ec4899", "#f59e0b", "#10b981", "#06b6d4",
  "#6366f1", "#a855f7", "#f43f5e", "#eab308",
];

export default function PlanPackageBreakdownPie({ data }) {
  const hasNoData = !Array.isArray(data) || data.length === 0;
  const hasSingleItem = data && data.length === 1;

  if (hasNoData) {
    return (
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
        <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
          Plan + Package Distribution
        </h4>
        <div className="flex items-center justify-center h-[180px]">
          <div className="text-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">No subscription data yet</p>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">Data will appear as users subscribe</p>
          </div>
        </div>
      </div>
    );
  }

  if (hasSingleItem) {
    const item = data[0];
    return (
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
        <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
          Plan + Package Distribution
        </h4>
        <div className="flex items-center justify-center h-[180px]">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-purple-100 to-purple-50 dark:from-purple-500/20 dark:to-purple-500/10 mb-3">
              <div className="text-center px-2">
                <div className="text-2xl font-bold text-purple-600 dark:text-purple-400">100%</div>
                <div className="text-[10px] text-purple-600/70 dark:text-purple-400/70 leading-tight">{item.name}</div>
              </div>
            </div>
            <p className="text-xs text-gray-400 dark:text-gray-500">No comparison data yet</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
      <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
        Plan + Package Distribution
      </h4>
      <ResponsiveContainer width="100%" height={180}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            outerRadius={70}
            label={false}
            strokeWidth={0}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name) => [`${value} users`, name]}
            contentStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '11px',
              padding: '6px 10px'
            }}
          />
          <Legend
            layout="vertical"
            verticalAlign="middle"
            align="right"
            iconType="circle"
            wrapperStyle={{ paddingLeft: 16, fontSize: '10px' }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
